import React from "react";
import { useAppSelector } from "../../../../store";
import { ICandidateDetails } from "../../../../store/superadmin/types";
import CustomButton from "../../../UI/Buttons/CustomButton";
import Download from "../../../UI/Icons/Download";
import ExternalLink from "../../../UI/Icons/ExternalLink";

interface DocumentAndContractProps {
  showDocuments: boolean;
  tfnFormUrl: string | null;
  superFormUrl: string | null;
  contractForm: string | null;
  reviewCandidateData: ICandidateDetails | null;
  handleDownloadDocument: (url: string) => void;
}

const DocumentAndContract: React.FC<DocumentAndContractProps> = ({
  showDocuments,
  tfnFormUrl,
  superFormUrl,
  contractForm,
  reviewCandidateData,
  handleDownloadDocument,
}) => {

  const reviewCandidateDetails = useAppSelector(
      (state) => state.superadmin.reviewCandidateData
  );
  const causualAndFairTerms = reviewCandidateDetails?.profile?.accept_terms ? "Accepted" : "No Data";
  const bankDetails = reviewCandidateDetails?.bank_account;
  const emergencyInfo = reviewCandidateDetails?.emergency_info;
  const contractFormData = reviewCandidateData?.contract_form_data;
  const isCandidateSigned = contractFormData?.candidate_signed;
  const isEmployerSigned = contractFormData?.employer_signed;
  const employeerSigningUrl = contractFormData?.employeer_signing_url;

  
  const isStage2Submitted =  reviewCandidateData?.profile?.current_stage === 1 &&
      reviewCandidateData?.profile?.review_status === "waiting";
      
  return (
    
      <div
        className={`d-flex flex-column gap-20 fw-400 text-black ${
          !showDocuments ? "d-none" : ""
        }`}
      >
        <div className="fs-22">Documents & Contract</div>
        {
          tfnFormUrl !== null && superFormUrl !== null && contractForm !== null && (
            <div className="fs-16">Below are the candidate's signed documents:</div>
          )
        }

        {tfnFormUrl && tfnFormUrl?.length > 0 ? (
          <div className="d-flex flex-column gap-10">
            <div className="fs-16 fw-700">TFN Declaration</div>
            <div className="d-flex">
              <CustomButton
                variant={"primary"}
                type="button"
                className="btn-theme bg-off-white text-black"
                onClick={() => {
                  handleDownloadDocument(tfnFormUrl);
                }}
              >
                <Download />
                {reviewCandidateData?.first_name}_
                {reviewCandidateData?.last_name}_TFN_Declaration.pdf
              </CustomButton>
            </div>
            <div className="bg-off-white min-h-1px"></div>
          </div>
        ) : (
          <div className="d-flex flex-column gap-10">
            <div className="fs-16 fw-700">TFN Declaration</div>
            <div className="text-grey-dark fs-13">Document not completed and signed by employee</div>
            <div className="bg-off-white min-h-1px"></div>
          </div>
        )}
        

        {superFormUrl && superFormUrl?.length > 0 ? (
          <div className="d-flex flex-column gap-10">
            <div className="fs-16 fw-700">Superannuation</div>
            <div className="d-flex">
              <CustomButton
                variant={"primary"}
                type="button"
                className="btn-theme bg-off-white text-black"
                onClick={() => {
                  handleDownloadDocument(superFormUrl);
                }}
              >
                <Download />
                {reviewCandidateData?.first_name}_
                {reviewCandidateData?.last_name}_Superannuation.pdf
              </CustomButton>
            </div>
            <div className="bg-off-white min-h-1px"></div>
          </div>
        ) : (
          <div className="d-flex flex-column gap-10">
            <div className="fs-16 fw-700">Superannuation</div>
            <div className="text-grey-dark fs-13">Document not completed and signed by employee</div>
            <div className="bg-off-white min-h-1px"></div>
          </div>
        )}

        {contractForm && contractForm?.length > 0 ? (
          <div className="d-flex flex-column gap-10">
            <div className="fs-16 fw-700">Contract</div>
            <div className="d-flex">
              <CustomButton
                variant={"primary"}
                type="button"
                className="btn-theme bg-off-white text-black"
                onClick={() => {
                  handleDownloadDocument(contractForm);
                }}
              >
                <Download />
                {reviewCandidateData?.first_name}_
                {reviewCandidateData?.last_name}_Contract.pdf
              </CustomButton>
            </div>
            <div className="bg-off-white min-h-1px"></div>
          </div>
        ) : (
          <div className="d-flex flex-column gap-10">
            <div className="fs-16 fw-700">Contract</div>
            <div className="text-grey-dark  fs-13">
              {isCandidateSigned
                ? "Document has been completed and signed by employee"
                : "Document not completed and signed by employee"}
            </div>
            <div className={`fs-13 ${isEmployerSigned ? "text-grey-dark" : (isStage2Submitted ? "text-alert" : "text-grey-dark")}`}>
              {isEmployerSigned
                ? "Document has been signed by super admin"
                : "Document not signed by super admin"}
            </div> 
            
            <div className="d-flex justify-content-start">
            {
              !isEmployerSigned && employeerSigningUrl && (
                <CustomButton
                  variant={"primary"}
                  className="btn-theme bg-teal text-black text-nowrap"
                  onClick={() => window.open(employeerSigningUrl, "_blank")}
                  contentClass="d-flex gap-8 align-items-center"              
                >
                <ExternalLink color={"black"} />  {"Sign Contract"}
              </CustomButton>  
              )
            }</div>           
            <div className="bg-off-white min-h-1px"></div>
          </div>
        )}


        {
          <div className="d-flex flex-column gap-10">
            <div className="fs-16 fw-700">Casual & Fair Work Statement</div>
            <div className="text-grey-dark fs-13">{causualAndFairTerms === "Accepted" ? "Yes, I have read and understood the Casual Employment Information Statement and Fair Work Statement." : "No data"}</div>
             <div className="bg-off-white min-h-1px"></div>
           </div>
        }

        {
          bankDetails === null ? (
            <div className="d-flex flex-column gap-10">
              <div className="fs-16 fw-700">Bank Account</div>
              <div className="text-grey-dark fs-13">No Data</div>
            </div>
          ) : (
            <div className="d-flex flex-column gap-10">
              <div className="fs-16 fw-700">Bank Account</div>
              {
                bankDetails?.account_name && bankDetails?.account_number ? (
                  <div className="text-grey-dark fs-13">Employee has provided all bank account details</div>
                ) : (
                  <div className="text-grey-dark fs-13">Employee has not provided all bank account details</div>
                )
              }
            </div>
          )
        }

        <div className="bg-off-white min-h-1px"></div>
        <div className="d-flex flex-column gap-10">
          <div className="fs-16 fw-700">Next of Kin</div>
          {emergencyInfo ? (
            <div className="d-flex flex-row flex-wrap gap-20 fs-13">
              {[
                ["First Name", emergencyInfo.first_name],
                ["Last Name", emergencyInfo.last_name],
                ["Mobile Number", emergencyInfo.phone_number],
                ["Relationship", emergencyInfo.relationship],
              ].map(([label, value]) => (
                <div key={label} className="d-flex flex-column gap-5">
                  <div className="text-grey-medium">{label}</div>
                  <div className="text-black">{value || "No Data"}</div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-grey-dark fs-13">No Data</div>
          )}
        </div>
      </div>
   
  );
};

export default DocumentAndContract;
